import { callIfDefined, safePublish } from "./utilities";
export var getGtmLabel = function getGtmLabel(videoObj) {
  return "".concat(videoObj.id).concat(videoObj.title ? " | ".concat(videoObj.title) : "");
};
export var firePlay = function firePlay(videoObj) {
  var analytics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  safePublish("analytics.videoPlay", videoObj);
  callIfDefined(analytics, "Video", "Play", getGtmLabel(videoObj));
};
export var firePause = function firePause(videoObj) {
  var analytics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  safePublish("analytics.videoPause", videoObj);
  callIfDefined(analytics, "Video", "Pause", getGtmLabel(videoObj));
};
export var fireBuffer = function fireBuffer(videoObj) {
  // GTM doesn't expect a buffer event, so we only send this to PubSub.
  safePublish("analytics.videoBuffer", videoObj);
};
export var fireEnd = function fireEnd(videoObj) {
  var analytics = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
  safePublish("analytics.videoEnd", videoObj);
  callIfDefined(analytics, "Video", "Finish", getGtmLabel(videoObj));
};